import BssoPermissions from 'components/LM/Bsso/Permissions';
import ValidationManageLists from 'components/LM/Voice/ValidationSearch/ValidationManageLists';

function VoicesValidationManageLists() {
	return (
		<BssoPermissions permissions={["voices"]} behaviour="error">
			<ValidationManageLists />
		</BssoPermissions>
	);
}

export default VoicesValidationManageLists;
